import { render } from "./CommissionBarWithBadge.vue?vue&type=template&id=4178d4ce&ts=true"
import script from "./CommissionBarWithBadge.vue?vue&type=script&lang=ts"
export * from "./CommissionBarWithBadge.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__